import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import RequestConfirmation from '../../requests/RequestConfirmation';
import { splitTalleres } from '../../../utils';
import styles from '../../../styles/shared/Checklist.module.css';
import { formatDate, formatTime } from '../../../utils/date';

const CartChecklist = ({ mostrarCheckList, setMostrarCheckList, solicitud }) => {


    const categoryRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (categoryRef.current && !categoryRef.current.contains(event.target)) {
                setMostrarCheckList(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setMostrarCheckList]);

    const [showConfirmar, setShowConfirmar] = useState(false);

    const handleAbrirConfirmar = (valor) =>{
        setShowConfirmar(valor)
    }
    const handleMostrarCheckList = () =>{
        setMostrarCheckList(false)
    }

    return (
        <>
            {mostrarCheckList && (
                <div className={styles.backdrop}>
                    <div className={styles.checklist} ref={categoryRef} onClick={(e) => e.stopPropagation()}>
                        <h1>Confirma el detalle de tu solicitud</h1>
                        <div className={styles.container}>
                            <div className={styles.tallerField}>
                                <b>Taller:</b>
                                <div className={styles.talleres}>
                                    {splitTalleres(solicitud.taller).map((taller, idx) => (
                                        <span className={styles.tallerChip} key={idx}>{taller}</span>
                                    ))}
                                </div>
                            </div>
                            <p><b>Fecha de retiro:</b> {formatDate(solicitud.fecha_creacion)}</p>
                            <p><b>Hora de retiro:</b> {formatTime(solicitud.fecha_creacion)}</p>
                            <p><b>Fecha de devolucion:</b> {formatDate(solicitud.fecha_resolucion)}</p>
                            <p><b>Hora de devolucion:</b> {formatTime(solicitud.fecha_resolucion)}</p>
                            <p><b>Productos:</b> {solicitud.carrito.items.length}</p>
                            <p>Descripción: {solicitud.descripcion}</p>
                            <div className={styles.button}>
                                <button onClick={() => { handleMostrarCheckList(); }}>Volver</button>
                                <button  onClick={() => { handleAbrirConfirmar(true); handleMostrarCheckList(); }}>Enviar Solicitud</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
                

            )}
            {showConfirmar&&(
                        <RequestConfirmation pedido={solicitud} setShowConfirmar={setShowConfirmar} />
                    )}
        </>
    );
};
const mapStateToProps = state =>({
    solicitud: state.Solicitud,
});

export default connect(mapStateToProps, {

  })(CartChecklist);
